var map = {
	"./logo-keno.png": 6877,
	"./logo-lotto535.png": 4155,
	"./logo-max3d.png": 1065,
	"./logo-max3dpro.png": 388,
	"./logo-mega.png": 5562,
	"./logo-power.png": 9737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9083;